import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "go-deeper-42e27",
  "use": "go-deeper-42e27-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"go-deeper-42e27\"><path d=\"M3.75 1.5h10.5a1.59 1.59 0 0 1 1.5 1.665v11.67a1.59 1.59 0 0 1-1.5 1.665H3.75a1.59 1.59 0 0 1-1.5-1.665V3.165A1.59 1.59 0 0 1 3.75 1.5zM.75 9h1.125\" /><path d=\"M3.907 9h11.198\" stroke-linecap=\"round\" stroke-dasharray=\"2.71 2.71\" /><path d=\"M16.125 9h1.125\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol